@if (post?.downloads || post?.videos || post?.links) {
<section class="post__objects">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <mat-tab-group class="tabs-spread" (selectedTabChange)="trackTabChange($event)">
          @if (post?.videos) {
          <mat-tab
            class="video-gallery"
            label="Videos"
            i18n-label="@@featureProductDetails-pageTabVideos"
            aria-label="Videos">
            @if (cookieConsent$ | async) {
            <planone-video-swiper [desktopVariant]="'list'" [slides]="post?.videos"></planone-video-swiper>
            } @else {
            <planone-youtube-video-cookie-consent-overlay></planone-youtube-video-cookie-consent-overlay>
            }
          </mat-tab>
          } @if (post?.downloads) {
          <mat-tab label="Downloads" i18n-label="@@featureProductDetails-pageTabDownloads" aria-label="Downloads">
            <planone-download-list
              [downloads]="post?.downloads"
              [flowsContent]="true"
              (downloadClick)="trackDownload($event.element, $event.download)"></planone-download-list>
          </mat-tab>
          } @if (post?.links) {
          <mat-tab label="Links" aria-label="Links" i18n-label="@@featureProductDetails-pageTabLinks">
            <planone-link-list
              [links]="post?.links"
              [flowsContent]="true"
              (linkClick)="trackClick($event.element, 'EXTERNAL_LINK', $event.link)"></planone-link-list>
          </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </div>
</section>
}
